<style>
#management {
  height: 84px;
}
#management .caption--long {
  display: block;
  max-width: 180px;
}
</style>

<template>
  <vue-custom-scrollbar
    class="v-bar-element"
    v-bind:settings="{suppressScrollY : true}"
    ref="bar-element"
  >
    <!-- <div
      class="group"
      v-if="$can('read','management_registry')"
    > -->
    <div class="group">
      <button
        class="ribbon-button btn--large"
        @click="show('addInvestmentCard')"
      >
        <span class="icon">
          <v-icon large>add_circle</v-icon>
        </span>
        <span class="caption">DODAJ INWESTYCJĘ</span>
      </button>
    </div>
    <div class="group">
      <button
        class="ribbon-button btn--large"
        @click="show('investmentsRegister')"
      >
        <span class="icon">
          <v-icon large>list_alt</v-icon>
        </span>
        <span class="caption">REJESTR INWESTYCJI</span>
      </button>
    </div>
    <div class="group">
      <button
        class="ribbon-button btn--large"
        @click="show('applicationsRegister')"
      >
        <span class="icon">
          <v-icon large>list_alt</v-icon>
        </span>
        <span class="caption">REJESTR WNIOSKÓW</span>
      </button>
    </div>
    <div class="group">
      <button
        class="ribbon-button"
        @click="show('techPreconditionsRegister')"
      >
        <span class="icon">
          <v-icon large>list_alt</v-icon>
        </span>
        <span class="caption caption--long">REJESTR WARUNKÓW TECHNICZNYCH</span>
      </button>
    </div>
    <div class="group">
      <button
        class="ribbon-button"
        @click="show('documentationRegister')"
      >
        <span class="icon">
          <v-icon large>list_alt</v-icon>
        </span>
        <span class="caption caption--long">REJESTR DOKUMENTACJI PROJEKTOWEJ</span>
      </button>
    </div>
    <div class="group">
      <button
        class="ribbon-button"
        @click="show('processRegister')"
      >
        <span class="icon">
          <v-icon large>list_alt</v-icon>
        </span>
        <span class="caption caption--long">REJESTR PROCESÓW INWESTYCYJNYCH</span>
      </button>
    </div>
    <div class="group">
      <button
        class="ribbon-button btn--large"
        @click="show('acceptanceRegister')"
      >
        <span class="icon">
          <v-icon large>list_alt</v-icon>
        </span>
        <span class="caption">REJESTR ODBIORÓW</span>
      </button>
    </div>
    <div class="group">
      <button
        class="ribbon-button btn--large"
        @click="toggleInvestmentsGeom"
        :class="{activeBtn : investmentsVisibility}"
      >
        <img style="width:36px; height:36px;" :src="require('../../../assets/maptools/map_marker_icon.png')">
        <span class="caption">WIZUALIZACJA NA MAPIE</span>
      </button>
    </div>
  </vue-custom-scrollbar>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar';

export default {
  components: {
    vueCustomScrollbar
  },
  data: () => ({
    investmentsVisibility: false,
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    map() {
      return this.$store.getters.getMap;
    }
  },
  methods: {
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    toggleInvestmentsGeom() {
      if (this.investmentsVisibility) {
        this.investmentsVisibility = false;
        this.$root.$emit("changeLayerVisibility", {layer: 'investments', visibility: false});
        this.$emit('hideInvestFilter');
      } else {
        this.investmentsVisibility = true;
        this.$root.$emit("addGeomLayer", {layerName: 'investments', actionName: 'getInvestments', fullName: 'Inwestycje'});
        this.$emit('showInvestFilter');
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/management/Management.vue